import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { BaseService } from './base.service';
import { ContactSalesSM } from '../service-models/contact-sales.s-m';
import { ApiResponse } from '../service-models/api-contracts/base/api-response';
import { ApiRequest } from '../service-models/api-contracts/base/api-request';
import { ContactSalesClient } from '../clients/contact-sales.client';

@Injectable({
  providedIn: 'root'
})
export class ContactSalesService  extends BaseService {

  constructor(private contactSalesClient:ContactSalesClient) { 
    super()
  }
  async contactSales(contactSales: ContactSalesSM): Promise<ApiResponse<ContactSalesSM>> {
    if (contactSales == null )// null checks
    {
      throw new Error(AppConstants.ErrorPrompts.Invalid_Input_Data);
    }
    else {
      let apiRequest = new ApiRequest<ContactSalesSM>();
      apiRequest.reqData = contactSales;
      return await this.contactSalesClient.AddContactSales(apiRequest);
    }
  }
}
